// biome-ignore lint/suspicious/noExplicitAny: out of convenience
export const reportErrorToSentry = (...args: any[]) => {
    if (!import.meta.env.DEV) {
        // Sentry removed, as this is not a customer facing spa
        console.warn(...args);
    }
};
